import { render } from "./PeppolInbox.vue?vue&type=template&id=6dcbee95&scoped=true"
import script from "./PeppolInbox.vue?vue&type=script&lang=js"
export * from "./PeppolInbox.vue?vue&type=script&lang=js"

import "./PeppolInbox.vue?vue&type=style&index=0&id=6dcbee95&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dcbee95"]])

export default __exports__